import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import Seo from "@/components/Seo";
import { PageHeader, Reveal } from "@/components/bits";
import { PRODUCTS } from "@/data/site";

const Products = () => (
  <>
    <Seo
      title="Solar & Electrical Products | Ambrotech Private Limited"
      description="Solar panels, on-grid and hybrid inverters, lithium batteries, mounting structures, DC and AC cables, MC4 connectors, BOS components, and cable lugs — price on request."
      path="/products"
    />

    <PageHeader
      eyebrow="Products"
      title="Solar, electrical, and industrial products"
      lead="Our product range for residential, commercial, and industrial requirements. Prices are provided on request based on specification and quantity."
    />

    <section className="mx-auto max-w-7xl px-5 py-16 sm:px-8 lg:py-20">
      <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3" data-testid="products-grid">
        {PRODUCTS.map((p, i) => (
          <Reveal key={p.id} delay={(i % 3) * 0.07} className="h-full">
            <article className="group flex h-full flex-col overflow-hidden rounded-2xl border border-slate-200 bg-white transition-all duration-300 hover:-translate-y-1 hover:shadow-[0_18px_40px_rgba(11,25,44,0.09)]" data-testid={`product-card-${p.id}`}>
              <div className="h-48 overflow-hidden">
                <img
                  src={p.image}
                  alt={p.alt}
                  loading="lazy"
                  className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-[1.04]"
                />
              </div>
              <div className="flex flex-1 flex-col p-6">
                <h2 className="font-display text-lg font-semibold leading-snug text-navy">{p.name}</h2>
                <p className="mt-2 flex-1 text-sm leading-relaxed text-slate-600">{p.description}</p>
                <div className="mt-5 flex items-center justify-between gap-3 border-t border-slate-100 pt-4">
                  <span className="text-xs font-semibold uppercase tracking-[0.14em] text-slate-400">
                    Price on Request
                  </span>
                  <Link
                    to="/contact"
                    state={{ product: p.name }}
                    data-testid={`enquire-now-${p.id}`}
                    className="group/btn inline-flex items-center gap-1.5 rounded-full bg-navy px-4 py-2 text-xs font-semibold text-white transition-colors hover:bg-brand"
                  >
                    Enquire Now
                    <ArrowRight className="h-3.5 w-3.5 transition-transform duration-200 group-hover/btn:translate-x-0.5" />
                  </Link>
                </div>
              </div>
            </article>
          </Reveal>
        ))}
      </div>

      <Reveal delay={0.1}>
        <p className="mt-12 text-center text-sm text-slate-500">
          Cannot find what you are looking for?{" "}
          <Link to="/contact" className="font-semibold text-navy underline decoration-brand decoration-2 underline-offset-4 transition-colors hover:text-brand" data-testid="products-other-enquiry-link">
            Send us your requirement
          </Link>{" "}
          — we also supply other solar, electrical, and industrial products as per availability.
        </p>
      </Reveal>
    </section>
  </>
);

export default Products;